import { useContext, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ContextApp } from '../../context';
import classnames from 'classnames';
import { FavoritesMoviesListContainer } from '../containers';
import Spinner from '../spinner';
import ErrorIndicator from '../error-indicator';

const FavoritesPage = ({ favoritesButtons, showFavoritesMovies, showFavoritesPremieres }) => {
    return (
        <section className='filmik filmik--favorites'>
            {favoritesButtons}
            <div className='filmik__content'>
                <FavoritesMoviesListContainer
                    showFavoritesMovies={showFavoritesMovies}
                    showFavoritesPremieres={showFavoritesPremieres}
                />
            </div>
        </section>
    );
};

FavoritesPage.propTypes = {
    favoritesButtons: PropTypes.element.isRequired,
    showFavoritesMovies: PropTypes.bool.isRequired,
    showFavoritesPremieres: PropTypes.bool.isRequired,
};

const FavoritesPageContainer = () => {
    const {  state: { loading, error, favoritesMoviesId, favoritesPremieresId }, actions: {moviesRequested, favoritesMoviesLoaded, favoritesMoviesReset, favoritesByIdError}, moviestoreService } = useContext(ContextApp);

    const [showFavoritesMovies, setShowFavoritesMovies] = useState(true);
    const [showFavoritesPremieres, setShowFavoritesPremieres] = useState(false);

    const onShowFavoritesMovies = () => {
        setShowFavoritesMovies(true);
        setShowFavoritesPremieres(false);
    };

    const onShowFavoritesPremieres = () => {
        setShowFavoritesMovies(false);
        setShowFavoritesPremieres(true);
    };

    const favoritesButtons = (
        <div className='filmik__favorites'>
            <button className={classnames('filmik__favorites-btn', {'filmik__favorites-btn--active': showFavoritesMovies})} type='button' onClick={onShowFavoritesMovies}>Избранное: {favoritesMoviesId.length}</button>
            <button className={classnames('filmik__favorites-btn', {'filmik__favorites-btn--active': showFavoritesPremieres})} type='button' onClick={onShowFavoritesPremieres}>Буду смотреть: {favoritesPremieresId.length}</button>
        </div>
    );

    useLayoutEffect(() => {
        if (favoritesMoviesId.length || favoritesPremieresId.length) {
            moviesRequested();
            moviestoreService.getMoviesById([favoritesMoviesId, favoritesPremieresId])
                .then(({favoritesMovies, favoritesPremieres}) => {
                    favoritesMoviesLoaded(favoritesMovies, favoritesPremieres);
                })
                .catch((error) => favoritesByIdError(error));
        }

        return () => {
            favoritesMoviesReset();
        }

        // eslint-disable-next-line
    }, []);

    if (error) {
        return <ErrorIndicator error={error} />
    }

    if (loading) {
        return <Spinner />;
    }

    return (
        <FavoritesPage
            favoritesButtons={favoritesButtons}
            showFavoritesMovies={showFavoritesMovies}
            showFavoritesPremieres={showFavoritesPremieres}
        />
    );
};

export default FavoritesPageContainer;